import React, { Component } from 'react';
import { connect } from 'react-redux';

import InputSimples from '../../components/Inputs/Simples';
import Voltar from '../../components/Links/Voltar';
import Loading from '../../components/Loading';
import * as actions from '../../actions/entregadores';

/** Mesmo fluxo de `Categorias/novaCategoria.js`: tela só do formulário, Voltar para a listagem. */
class NovoEntregador extends Component {

	state = {
		nome: "",
		telefoneWhatsApp: "",
		ativo: true,
		saving: false,
	}

	componentDidMount(){
		const { usuario } = this.props;
		if(usuario && usuario.loja){
			this.props.getEntregadores(usuario.loja).then(() => this.hidratarEdicao());
		}else{
			this.hidratarEdicao();
		}
	}

	componentDidUpdate(prevProps){
		if(!prevProps.usuario && this.props.usuario){
			this.props.getEntregadores(this.props.usuario.loja).then(() => this.hidratarEdicao());
		}
		if(prevProps.match.params.id !== this.props.match.params.id && this.props.usuario && this.props.usuario.loja){
			this.props.getEntregadores(this.props.usuario.loja).then(() => this.hidratarEdicao());
		}
	}

	hidratarEdicao = () => {
		const id = this.props.match.params.id;
		if(!id){
			this.setState({ nome: "", telefoneWhatsApp: "", ativo: true });
			return;
		}
		const { lista } = this.props;
		const row = (lista || []).find((e) => e && String(e._id) === String(id));
		if(!row){
			window.alert('Entregador não encontrado.');
			this.props.history.push('/entregadores');
			return;
		}
		this.setState({
			nome: row.nome || "",
			telefoneWhatsApp: row.telefoneWhatsApp || "",
			ativo: row.ativo !== false,
		});
	}

	onChangeNome = (ev) => this.setState({ nome: ev.target.value });

	onChangeWhatsApp = (ev) => this.setState({ telefoneWhatsApp: ev.target.value });

	onChangeAtivo = (ev) => this.setState({ ativo: ev.target.checked });

	_ehErro = (data) => {
		if(!data) return true;
		if(data.status && data.message){
			window.alert(data.message);
			return true;
		}
		if(data.error){
			window.alert(typeof data.error === 'string' ? data.error : 'Erro ao processar.');
			return true;
		}
		return false;
	}

	salvar = () => {
		const { nome, telefoneWhatsApp, ativo, saving } = this.state;
		const { usuario, match, history } = this.props;
		if(saving) return;
		if(!nome.trim() || !telefoneWhatsApp.trim()){
			window.alert('Preencha nome e WhatsApp.');
			return;
		}
		const body = { nome: nome.trim(), telefoneWhatsApp: telefoneWhatsApp.trim(), ativo };
		const editId = match.params.id;
		this.setState({ saving: true });
		const done = () => this.setState({ saving: false });
		if(editId){
			this.props.updateEntregador(usuario.loja, editId, body)
				.then((data) => {
					done();
					if(this._ehErro(data)) return;
					history.push('/entregadores');
				});
		}else{
			this.props.createEntregador(usuario.loja, body)
				.then((data) => {
					done();
					if(this._ehErro(data)) return;
					history.push('/entregadores');
				});
		}
	}

	render(){
		const { usuario, match } = this.props;
		const { nome, telefoneWhatsApp, ativo, saving } = this.state;
		const editId = match.params.id;
		const titulo = editId ? 'Editar entregador' : 'Novo entregador';
		const labelBotao = saving ? 'Salvando…' : (editId ? 'Salvar alterações' : 'Adicionar');

		if(!usuario) return <Loading />;

		return (
			<div className="Category container-centered">
				<div className="head">
					<Voltar path="/entregadores" />
					<h1>{titulo}</h1>
				</div>

				<div className="items">
					<div className="form">
						<div className="double">
							<InputSimples type="text" label="Nome:" value={nome} onChange={this.onChangeNome} />
							<InputSimples type="text" label="WhatsApp (DDD + número):" value={telefoneWhatsApp} onChange={this.onChangeWhatsApp} />
						</div>
					</div>
					<label className="entregadoresNovo-checkAtivo">
						<input type="checkbox" checked={ativo} onChange={this.onChangeAtivo} />
						<span>Ativo</span>
					</label>
					<div className="ButtonSubmit">
						<button type="button" onClick={this.salvar} disabled={saving}>{labelBotao}</button>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	usuario: state.auth.usuario,
	lista: state.entregador.lista,
});

export default connect(mapStateToProps, actions)(NovoEntregador);
